import { Component, OnInit } from '@angular/core';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-admin-listof-dgcs',
  templateUrl: './admin-listof-dgcs.component.html',
  styleUrls: ['./admin-listof-dgcs.component.css']
})
export class AdminListofDGCsComponent implements OnInit {
  statelists: any[];
  selectedstate: any = 'undefined';
  dgcList: any;
  count: any = 0;
  

  constructor(
    private constants : ConstantsModule,
    private submitdataSerivce : SubmitdataService) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getstateslist();
  }

  getstateslist(){
    let postdata = {};
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        })
      }
    });
  
  }

  getListofDGCs(){
    // if(this.selectedstate == 'undefined'){
    //   this.selectedstate = "f78f615d-e270-4f93-90ac-27608e756b85";
    // }
    this.dgcList = [];
    this.submitdataSerivce.getDGCsList(this.selectedstate).subscribe(data =>{
      this.count = 0;
      if(data.status){
        this.dgcList = data['data']
        // this.dgcList = this.formatdgclist(data['data']);
      }
      
    })
    // this.selectedstate = 'undefined'
  }

  formatState(uid){
    let stateName;    
    this.statelists.forEach(state=>{
      if(state['uuid'] == uid){
        stateName = state['name'];
      }
    })
    return this.titleCase(stateName);
  }
  initializeSno(){
    this.count=0;
  }

  getSno(){
    this.count = this.count+1;
    return this.count;
  }

  titleCase(str){    
    str = str.toLowerCase().split(' ');
    for(var i = 0; i < str.length; i++){
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  // formatdgclist(rawdata){
  //   let finalData = [];
  //   if(rawdata.length != undefined){
  //     finalData = rawdata;      
  //   } else {
      
  //     Object.keys(rawdata).forEach(state => {
  //       let temp = {};
  //       this.statelists.forEach(item=>{
  //         if(state == item['uuid']){
  //           temp['state'] = item['name'];            
  //         }

  //         rawdata[state].forEach(sItem=>{

  //         })
  //       })
  //     //   finalData = finalData.concat(state);
        
  //     });
  //     return rawdata;
  //   }
  //   return finalData;
  // }

  printListofDGCs(){
    let label = "List of DGCs";
      // this.activeSpinner = true;
      let DATA = document.getElementById('content');
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
        var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(30);
        pdf.text(label, 600,30);
        pdf.addImage(imgData, 'JPG', top_left_margin+350, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin+350, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("List of DGCs.pdf");
      });
      // this.activeSpinner = false;
  }

}
